export default "assets/slider-arrow-29df0905.svg";